// extracted by mini-css-extract-plugin
export default {"curtain":"Intro_curtain__P1a0D","word":"Intro_word__RCrpu","line":"Intro_line__VF+7s"};